import React from 'react';

import { Box, chakra } from '@chakra-ui/react';

export const Logo = (props: any) => {
  const color = props.color || '#000';

  return (
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      width="full"
      height="full"
      //px={24}
      maxH={32}
      viewBox="0 0 1891 945"
      //viewBox="-80 0 265 82"
      css={{
        '& .squarel': {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: 'none'
        },

        '& .k': {
          stroke: '#bae0e2',
          strokeWidth: '15px'
          //strokeDasharray: "5"
        }
      }}
      {...props}
      color={color}
    >
      <path
        fill="currentColor"
        d="M 1785.56,533.78
           C 1791.89,533.78 1798.33,533.79 1804.88,533.80
             1805.29,533.80 1805.62,533.46 1805.62,533.04
             1805.62,533.04 1805.62,533.04 1805.62,533.04
             1805.62,533.04 1805.62,466.56 1805.62,466.56
             1805.62,465.32 1806.62,464.32 1807.86,464.32
             1807.86,464.32 1807.86,464.32 1807.86,464.32
             1807.86,464.32 1838.82,464.32 1838.82,464.32
             1838.82,464.32 1838.82,464.32 1838.82,464.32
             1840.12,464.32 1841.18,465.38 1841.18,466.68
             1841.18,466.68 1841.18,466.68 1841.18,466.68
             1841.18,466.68 1841.18,635.92 1841.18,635.92
             1841.18,635.92 1841.18,635.92 1841.18,635.92
             1841.18,637.29 1840.07,638.40 1838.70,638.40
             1838.70,638.40 1838.70,638.40 1838.70,638.40
             1838.70,638.40 1808.00,638.40 1808.00,638.40
             1808.00,638.40 1808.00,638.40 1808.00,638.40
             1806.67,638.40 1805.60,637.32 1805.60,635.98
             1805.60,635.98 1805.60,635.98 1805.60,635.98
             1805.60,635.98 1805.60,567.74 1805.60,567.74
             1805.60,567.74 1805.60,567.74 1805.60,567.74
             1805.60,567.33 1805.27,566.99 1804.86,566.98
             1803.87,566.95 1797.44,566.94 1785.56,566.94
             1773.68,566.94 1767.24,566.95 1766.24,566.98
             1765.84,567.00 1765.52,567.33 1765.52,567.74
             1765.52,567.74 1765.52,567.74 1765.52,567.74
             1765.52,567.74 1765.50,635.98 1765.50,635.98
             1765.50,635.98 1765.50,635.98 1765.50,635.98
             1765.50,637.32 1764.43,638.40 1763.10,638.40
             1763.10,638.40 1763.10,638.40 1763.10,638.40
             1763.10,638.40 1732.40,638.40 1732.40,638.40
             1732.40,638.40 1732.40,638.40 1732.40,638.40
             1731.03,638.40 1729.92,637.29 1729.92,635.92
             1729.92,635.92 1729.92,635.92 1729.92,635.92
             1729.92,635.92 1729.94,466.68 1729.94,466.68
             1729.94,466.68 1729.94,466.68 1729.94,466.68
             1729.94,465.38 1731.00,464.32 1732.30,464.32
             1732.30,464.32 1763.26,464.32 1763.26,464.32
             1763.26,464.32 1763.26,464.32 1763.26,464.32
             1764.50,464.32 1765.50,465.32 1765.50,466.56
             1765.50,466.56 1765.50,533.04 1765.50,533.04
             1765.50,533.04 1765.50,533.04 1765.50,533.04
             1765.50,533.46 1765.83,533.80 1766.24,533.80
             1772.79,533.79 1779.23,533.78 1785.56,533.78 Z
           M 1656.26,464.38
           C 1686.05,464.45 1703.39,464.51 1708.28,464.56
             1709.41,464.56 1710.32,465.47 1710.32,466.60
             1710.32,466.60 1710.32,466.60 1710.32,466.60
             1710.32,466.60 1710.32,493.94 1710.32,493.94
             1710.32,495.43 1709.11,496.64 1707.62,496.64
             1707.62,496.64 1707.62,496.64 1707.62,496.64
             1707.62,496.64 1675.46,496.64 1675.46,496.64
             1675.46,496.64 1675.46,496.64 1675.46,496.64
             1674.84,496.64 1674.33,497.14 1674.32,497.76
             1674.32,497.76 1673.98,635.38 1673.98,635.38
             1673.98,635.38 1673.98,635.38 1673.98,635.38
             1673.98,636.93 1672.74,638.20 1671.20,638.24
             1670.19,638.28 1665.06,638.29 1655.82,638.26
             1646.58,638.23 1641.45,638.20 1640.44,638.16
             1638.91,638.11 1637.68,636.85 1637.68,635.30
             1637.68,635.29 1637.68,635.29 1637.68,635.28
             1637.68,635.28 1638.02,497.66 1638.02,497.66
             1638.01,497.05 1637.51,496.55 1636.90,496.54
             1636.90,496.54 1604.74,496.38 1604.74,496.38
             1604.74,496.38 1604.74,496.38 1604.74,496.38
             1603.25,496.38 1602.04,495.17 1602.04,493.68
             1602.04,493.67 1602.04,493.67 1602.04,493.66
             1602.04,493.66 1602.18,466.34 1602.18,466.34
             1602.18,466.34 1602.18,466.34 1602.18,466.34
             1602.18,465.21 1603.09,464.30 1604.22,464.30
             1604.23,464.30 1604.23,464.30 1604.24,464.30
             1609.13,464.27 1626.47,464.30 1656.26,464.38 Z
           M 1513.38,574.30
           C 1512.94,574.30 1512.58,574.66 1512.58,575.10
             1512.58,575.10 1512.58,636.00 1512.58,636.00
             1512.58,636.00 1512.58,636.00 1512.58,636.00
             1512.58,637.23 1511.58,638.22 1510.34,638.22
             1510.34,638.22 1510.34,638.22 1510.34,638.22
             1510.34,638.22 1478.96,638.22 1478.96,638.22
             1477.55,638.22 1476.40,637.07 1476.40,635.66
             1476.40,635.66 1476.40,635.66 1476.40,635.66
             1476.40,635.66 1476.40,467.28 1476.40,467.28
             1476.40,467.28 1476.40,467.28 1476.40,467.28
             1476.40,465.66 1477.72,464.34 1479.34,464.34
             1479.34,464.34 1479.34,464.34 1479.34,464.34
             1506.49,464.37 1521.37,464.41 1524.00,464.46
             1552.72,465.02 1580.34,475.16 1583.92,507.52
             1586.14,527.38 1584.04,547.34 1568.00,560.04
             1564.75,562.60 1561.45,564.85 1558.10,566.80
             1557.69,567.04 1557.51,567.54 1557.68,567.98
             1557.68,567.98 1584.64,633.54 1584.64,633.54
             1585.23,634.98 1584.71,636.64 1583.40,637.48
             1580.76,639.16 1564.42,638.22 1551.84,638.22
             1549.87,638.22 1548.19,637.01 1547.48,635.30
             1547.48,635.30 1522.92,575.58 1522.92,575.58
             1522.61,574.83 1521.88,574.30 1521.02,574.30
             1521.02,574.30 1513.38,574.30 1513.38,574.30 Z
           M 1512.54,496.26
           C 1512.54,496.26 1512.62,543.66 1512.62,543.66
             1512.63,544.24 1513.10,544.70 1513.68,544.70
             1513.68,544.70 1513.68,544.70 1513.68,544.70
             1513.68,544.70 1526.74,544.68 1526.74,544.68
             1538.36,544.66 1547.76,535.49 1547.74,524.20
             1547.74,524.20 1547.74,524.20 1547.74,524.20
             1547.74,524.20 1547.74,515.56 1547.74,515.56
             1547.72,504.27 1538.28,495.14 1526.66,495.16
             1526.66,495.16 1526.66,495.16 1526.66,495.16
             1526.66,495.16 1513.60,495.18 1513.60,495.18
             1513.60,495.18 1513.60,495.18 1513.60,495.18
             1513.01,495.18 1512.54,495.65 1512.54,496.24
             1512.54,496.25 1512.54,496.25 1512.54,496.26
             1512.54,496.26 1512.54,496.26 1512.54,496.26 Z
           M 1445.18,464.38
           C 1445.18,464.38 1445.18,464.38 1445.18,464.38
             1446.78,464.38 1448.08,465.68 1448.08,467.28
             1448.08,467.28 1448.08,635.36 1448.08,635.36
             1448.08,635.36 1448.08,635.36 1448.08,635.36
             1448.08,636.96 1446.78,638.26 1445.18,638.26
             1445.18,638.26 1445.18,638.26 1445.18,638.26
             1445.18,638.26 1415.34,638.26 1415.34,638.26
             1415.34,638.26 1415.34,638.26 1415.34,638.26
             1413.74,638.26 1412.44,636.96 1412.44,635.36
             1412.44,635.36 1412.44,635.36 1412.44,635.36
             1412.44,635.36 1412.44,467.28 1412.44,467.28
             1412.44,465.68 1413.74,464.38 1415.34,464.38
             1415.34,464.38 1415.34,464.38 1415.34,464.38
             1415.34,464.38 1445.18,464.38 1445.18,464.38 Z
           M 1336.64,579.52
           C 1336.64,579.63 1336.73,579.72 1336.84,579.72
             1336.95,579.72 1337.04,579.63 1337.04,579.52
             1337.04,579.52 1356.26,466.94 1356.26,466.94
             1356.51,465.52 1357.74,464.44 1359.23,464.44
             1359.24,464.44 1359.24,464.44 1359.24,464.44
             1359.24,464.44 1391.06,464.44 1391.06,464.44
             1391.96,464.44 1392.69,465.18 1392.69,466.08
             1392.69,466.19 1392.68,466.30 1392.66,466.40
             1392.66,466.40 1357.56,635.70 1357.56,635.70
             1357.26,637.19 1355.95,638.26 1354.44,638.26
             1354.44,638.26 1321.64,638.26 1321.64,638.26
             1320.23,638.26 1319.01,637.26 1318.72,635.86
             1318.72,635.86 1297.46,531.76 1297.46,531.76
             1297.42,531.57 1297.25,531.43 1297.05,531.43
             1296.85,531.43 1296.68,531.57 1296.64,531.76
             1296.64,531.76 1275.36,634.44 1275.36,634.44
             1274.91,636.62 1272.98,638.26 1270.66,638.26
             1270.66,638.26 1270.66,638.26 1270.66,638.26
             1270.66,638.26 1237.74,638.26 1237.74,638.26
             1236.82,638.26 1236.03,637.61 1235.86,636.72
             1235.86,636.72 1201.42,468.24 1201.42,468.24
             1201.40,468.13 1201.38,468.02 1201.37,467.91
             1201.20,466.13 1202.50,464.55 1204.27,464.37
             1204.38,464.36 1204.49,464.36 1204.60,464.36
             1211.24,464.41 1220.57,464.41 1232.60,464.34
             1234.75,464.34 1236.17,464.95 1236.88,466.18
             1237.05,466.49 1237.38,468.07 1237.86,470.94
             1244.02,507.35 1249.97,543.36 1255.72,578.96
             1255.75,579.09 1255.87,579.19 1256.01,579.19
             1256.15,579.19 1256.26,579.10 1256.30,578.98
             1256.30,578.98 1279.66,466.30 1279.66,466.30
             1279.89,465.19 1280.86,464.40 1281.98,464.40
             1281.98,464.40 1313.16,464.40 1313.16,464.40
             1314.33,464.40 1315.34,465.24 1315.56,466.40
             1315.56,466.40 1336.64,579.52 1336.64,579.52 Z
           M 1005.22,609.12
           C 1019.20,609.16 1025.40,599.64 1025.48,586.50
             1025.73,546.58 1025.86,506.69 1025.86,466.82
             1025.86,465.53 1026.92,464.48 1028.22,464.48
             1028.22,464.48 1028.22,464.48 1028.22,464.48
             1028.22,464.48 1059.20,464.48 1059.20,464.48
             1059.20,464.48 1059.20,464.48 1059.20,464.48
             1060.50,464.48 1061.56,465.54 1061.56,466.84
             1061.44,522.44 1061.37,562.16 1061.36,586.00
             1061.32,620.46 1038.96,640.50 1005.16,640.44
             971.36,640.36 949.08,620.22 949.20,585.76
             949.28,561.93 949.37,522.22 949.48,466.62
             949.48,466.62 949.48,466.62 949.48,466.62
             949.48,465.32 950.54,464.26 951.84,464.26
             951.84,464.26 982.82,464.38 982.82,464.38
             982.82,464.38 982.83,464.38 982.83,464.38
             984.13,464.38 985.18,465.44 985.18,466.73
             985.18,466.73 985.18,466.74 985.18,466.74
             985.01,506.61 984.97,546.50 985.06,586.42
             985.10,599.54 991.26,609.10 1005.22,609.12 Z
           M 872.54,464.42
           C 881.07,464.39 887.86,464.40 892.90,464.44
             894.09,464.44 895.12,465.27 895.40,466.44
             895.40,466.44 934.34,634.46 934.34,634.46
             934.39,634.68 934.42,634.91 934.42,635.14
             934.42,636.79 933.09,638.12 931.44,638.12
             931.44,638.12 901.40,638.12 901.40,638.12
             901.40,638.12 901.40,638.12 901.40,638.12
             899.84,638.12 898.54,637.01 898.24,635.54
             898.24,635.54 892.04,605.20 892.04,605.20
             891.93,604.65 891.44,604.23 890.86,604.22
             889.50,604.21 883.53,604.21 872.96,604.24
             862.39,604.28 856.42,604.31 855.06,604.34
             854.48,604.35 853.99,604.77 853.88,605.32
             853.88,605.32 847.86,635.68 847.86,635.68
             847.57,637.16 846.27,638.28 844.70,638.28
             844.70,638.28 844.70,638.28 844.70,638.28
             844.70,638.28 814.68,638.46 814.68,638.46
             814.67,638.46 814.66,638.46 814.65,638.46
             813.00,638.46 811.67,637.13 811.67,635.48
             811.67,635.25 811.69,635.03 811.74,634.82
             811.74,634.82 849.70,466.58 849.70,466.58
             849.97,465.41 851.00,464.57 852.20,464.56
             857.23,464.49 864.01,464.45 872.54,464.42 Z
           M 859.60,573.84
           C 859.59,573.88 859.59,573.93 859.59,573.98
             859.59,574.36 859.89,574.66 860.27,574.66
             860.27,574.66 860.28,574.66 860.28,574.66
             860.28,574.66 885.96,574.56 885.96,574.56
             885.96,574.56 885.97,574.56 885.97,574.56
             886.35,574.56 886.65,574.26 886.65,573.88
             886.65,573.84 886.65,573.80 886.64,573.76
             886.64,573.76 873.56,506.96 873.56,506.96
             873.50,506.64 873.23,506.40 872.89,506.40
             872.55,506.40 872.28,506.64 872.22,506.96
             872.22,506.96 859.60,573.84 859.60,573.84 Z
           M 737.82,566.86
           C 725.97,566.85 719.55,566.85 718.56,566.88
             718.15,566.89 717.82,567.23 717.82,567.64
             717.82,567.64 717.82,567.64 717.82,567.64
             717.82,567.64 717.78,635.72 717.78,635.72
             717.77,637.05 716.70,638.12 715.38,638.12
             715.38,638.12 715.38,638.12 715.38,638.12
             715.38,638.12 684.76,638.10 684.76,638.10
             683.39,638.10 682.28,636.99 682.28,635.62
             682.28,635.62 682.28,635.62 682.28,635.62
             682.28,635.62 682.42,466.80 682.42,466.80
             682.43,465.51 683.48,464.46 684.78,464.46
             684.78,464.46 684.78,464.46 684.78,464.46
             684.78,464.46 715.66,464.48 715.66,464.48
             716.89,464.49 717.88,465.49 717.88,466.72
             717.88,466.72 717.88,466.72 717.88,466.72
             717.88,466.72 717.84,533.02 717.84,533.02
             717.84,533.02 717.84,533.02 717.84,533.02
             717.84,533.44 718.17,533.78 718.58,533.78
             725.10,533.78 731.52,533.78 737.84,533.78
             744.16,533.79 750.59,533.81 757.12,533.82
             757.53,533.82 757.86,533.48 757.86,533.06
             757.86,533.06 757.86,533.06 757.86,533.06
             757.86,533.06 757.90,466.74 757.90,466.74
             757.90,466.74 757.90,466.74 757.90,466.74
             757.90,465.50 758.90,464.50 760.14,464.50
             760.14,464.50 760.14,464.50 760.14,464.50
             760.14,464.50 791.02,464.54 791.02,464.54
             791.02,464.54 791.02,464.54 791.02,464.54
             792.32,464.54 793.37,465.59 793.38,466.88
             793.38,466.88 793.26,635.70 793.26,635.70
             793.26,635.70 793.26,635.70 793.26,635.70
             793.26,637.07 792.15,638.18 790.78,638.18
             790.78,638.18 790.78,638.18 790.78,638.18
             790.78,638.18 760.16,638.16 760.16,638.16
             758.83,638.16 757.76,637.08 757.76,635.74
             757.76,635.74 757.76,635.74 757.76,635.74
             757.76,635.74 757.82,567.68 757.82,567.68
             757.82,567.68 757.82,567.68 757.82,567.68
             757.82,567.27 757.49,566.93 757.08,566.92
             756.09,566.89 749.67,566.87 737.82,566.86 Z
           M 1114.78,582.32
           C 1115.41,583.33 1115.71,585.49 1115.68,588.78
             1115.54,601.22 1121.68,609.28 1135.00,608.88
             1150.40,608.40 1156.68,591.38 1147.40,580.10
             1144.25,576.29 1140.20,572.99 1135.24,570.22
             1111.98,557.26 1085.14,547.48 1082.74,516.64
             1080.38,486.52 1097.96,465.70 1127.34,462.48
             1156.58,459.28 1179.74,475.56 1186.94,504.54
             1187.86,508.22 1188.22,511.79 1188.02,515.24
             1187.90,517.23 1186.31,518.82 1184.32,518.96
             1184.32,518.96 1154.32,520.98 1154.32,520.98
             1154.24,520.98 1154.16,520.99 1154.08,520.99
             1152.23,520.99 1150.69,519.65 1150.38,517.88
             1149.68,513.84 1149.94,507.92 1148.40,503.74
             1144.60,493.58 1132.60,490.84 1124.16,496.54
             1117.70,500.90 1118.14,512.86 1121.46,519.08
             1122.94,521.87 1126.30,524.65 1131.54,527.44
             1146.58,535.45 1156.90,541.14 1162.50,544.50
             1183.13,556.85 1191.33,575.35 1187.10,600.02
             1183.04,623.88 1165.04,637.16 1141.38,639.86
             1107.04,643.76 1078.94,622.60 1078.00,586.92
             1078.00,586.88 1078.00,586.85 1078.00,586.81
             1078.00,584.76 1079.60,583.07 1081.62,582.94
             1081.62,582.94 1111.98,580.90 1111.98,580.90
             1112.05,580.90 1112.11,580.89 1112.18,580.89
             1113.27,580.89 1114.23,581.46 1114.78,582.32
             1114.78,582.32 1114.78,582.32 1114.78,582.32 Z
           M 268.82,333.66
           C 268.82,333.66 236.76,374.40 236.76,374.40
             236.35,374.93 236.36,375.66 236.78,376.16
             246.54,387.73 249.18,400.50 244.70,414.46
             237.84,435.84 209.72,446.50 189.54,435.26
             175.51,427.46 168.95,414.92 169.84,397.64
             171.02,375.12 189.26,362.82 211.30,362.80
             211.85,362.80 212.37,362.54 212.70,362.10
             212.70,362.10 247.86,317.44 247.86,317.44
             248.21,317.01 248.26,316.40 247.98,315.90
             232.78,289.80 250.40,260.28 279.94,260.44
             302.34,260.58 318.42,282.16 315.42,304.08
             315.32,304.82 315.62,305.56 316.20,306.02
             316.20,306.02 347.14,330.38 347.14,330.38
             347.41,330.60 347.76,330.72 348.14,330.72
             348.53,330.72 348.88,330.59 349.16,330.36
             360.72,321.11 372.98,318.89 385.94,323.70
             386.17,323.79 386.41,323.83 386.67,323.83
             387.22,323.83 387.71,323.62 388.08,323.28
             388.08,323.28 435.52,278.78 435.52,278.78
             436.07,278.27 436.34,277.52 436.24,276.78
             435.69,272.91 435.37,269.83 435.26,267.54
             434.20,245.44 450.72,228.22 472.34,226.30
             493.58,224.40 512.52,240.26 515.66,260.72
             518.20,277.30 509.50,292.44 494.76,300.42
             482.03,307.31 468.55,306.83 454.34,298.98
             454.14,298.87 453.90,298.80 453.65,298.80
             453.27,298.80 452.92,298.95 452.66,299.20
             452.66,299.20 407.00,342.00 407.00,342.00
             406.71,342.27 406.52,342.66 406.52,343.09
             406.52,343.29 406.57,343.48 406.64,343.66
             421.40,378.68 384.16,412.34 351.54,390.20
             340.43,382.67 334.96,371.31 335.12,356.14
             335.12,356.13 335.12,356.11 335.12,356.10
             335.12,355.30 334.74,354.59 334.16,354.14
             334.16,354.14 301.10,328.12 301.10,328.12
             300.67,327.78 300.06,327.75 299.60,328.06
             290.32,334.07 280.52,335.78 270.20,333.18
             270.10,333.16 270.00,333.14 269.89,333.14
             269.45,333.14 269.07,333.35 268.82,333.66
             268.82,333.66 268.82,333.66 268.82,333.66 Z
           M 1651.70,278.40
           C 1651.70,278.40 1699.70,278.40 1699.70,278.40
             1700.80,278.40 1701.70,279.30 1701.70,280.40
             1701.70,280.40 1701.70,315.16 1701.70,315.16
             1701.70,316.26 1700.80,317.16 1699.70,317.16
             1699.70,317.16 1651.72,317.16 1651.72,317.16
             1650.62,317.16 1649.72,318.06 1649.72,319.16
             1649.72,319.16 1649.72,375.38 1649.72,375.38
             1649.72,376.48 1650.62,377.38 1651.72,377.38
             1651.72,377.38 1720.08,377.38 1720.08,377.38
             1721.18,377.38 1722.08,378.28 1722.08,379.38
             1722.08,379.38 1722.08,416.42 1722.08,416.42
             1722.08,417.52 1721.18,418.42 1720.08,418.42
             1720.08,418.42 1607.64,418.42 1607.64,418.42
             1606.54,418.42 1605.64,417.52 1605.64,416.42
             1605.64,416.42 1605.64,183.06 1605.64,183.06
             1605.64,181.96 1606.54,181.06 1607.64,181.06
             1607.64,181.06 1717.32,181.06 1717.32,181.06
             1718.42,181.06 1719.32,181.96 1719.32,183.06
             1719.32,183.06 1719.32,219.14 1719.32,219.14
             1719.32,220.24 1718.42,221.14 1717.32,221.14
             1717.32,221.14 1651.70,221.14 1651.70,221.14
             1650.60,221.14 1649.70,222.04 1649.70,223.14
             1649.70,223.14 1649.70,276.40 1649.70,276.40
             1649.70,277.50 1650.60,278.40 1651.70,278.40
             1651.70,278.40 1651.70,278.40 1651.70,278.40 Z
           M 1518.92,328.78
           C 1518.97,328.83 1519.04,328.86 1519.12,328.86
             1519.28,328.86 1519.42,328.72 1519.42,328.56
             1519.42,328.56 1519.26,183.50 1519.26,183.50
             1519.26,182.20 1520.31,181.15 1521.62,181.14
             1521.62,181.14 1558.12,181.10 1558.12,181.10
             1559.53,181.10 1560.67,182.23 1560.68,183.62
             1560.68,183.62 1560.92,415.42 1560.92,415.42
             1560.92,415.42 1560.92,415.42 1560.92,415.42
             1560.92,416.97 1559.67,418.23 1558.12,418.24
             1558.12,418.24 1516.36,418.30 1516.36,418.30
             1514.78,418.30 1513.35,417.32 1512.80,415.84
             1512.80,415.84 1455.26,265.18 1455.26,265.18
             1455.21,265.01 1455.05,264.89 1454.86,264.89
             1454.63,264.89 1454.44,265.08 1454.44,265.31
             1454.44,265.31 1454.44,265.32 1454.44,265.32
             1454.42,270.06 1455.48,279.14 1455.48,286.22
             1455.47,354.81 1455.47,396.66 1455.48,411.78
             1455.49,413.65 1455.44,415.04 1455.32,415.96
             1455.13,417.30 1453.97,418.31 1452.60,418.30
             1452.60,418.30 1417.64,418.34 1417.64,418.34
             1416.39,418.34 1415.38,417.32 1415.38,416.06
             1415.38,416.06 1415.38,416.06 1415.38,416.06
             1415.38,416.06 1415.12,183.46 1415.12,183.46
             1415.12,182.21 1416.12,181.19 1417.36,181.18
             1417.36,181.18 1461.38,181.14 1461.38,181.14
             1462.88,181.14 1464.23,182.07 1464.74,183.48
             1493.54,260.31 1511.28,308.20 1517.96,327.16
             1518.23,327.91 1518.55,328.45 1518.92,328.78 Z
           M 1367.28,181.06
           C 1368.86,181.06 1370.14,182.34 1370.14,183.92
             1370.14,183.92 1370.14,183.92 1370.14,183.92
             1370.14,183.92 1370.14,415.56 1370.14,415.56
             1370.14,415.56 1370.14,415.56 1370.14,415.56
             1370.14,417.14 1368.86,418.42 1367.28,418.42
             1367.28,418.42 1328.16,418.42 1328.16,418.42
             1326.58,418.42 1325.30,417.14 1325.30,415.56
             1325.30,415.56 1325.30,415.56 1325.30,415.56
             1325.30,415.56 1325.30,183.92 1325.30,183.92
             1325.30,183.92 1325.30,183.92 1325.30,183.92
             1325.30,182.34 1326.58,181.06 1328.16,181.06
             1328.16,181.06 1367.28,181.06 1367.28,181.06 Z
           M 1133.88,182.94
           C 1133.88,182.94 1133.88,182.94 1133.88,182.94
             1133.88,182.00 1134.64,181.23 1135.58,181.22
             1161.86,180.93 1187.32,180.95 1211.96,181.30
             1237.06,181.64 1260.66,195.68 1270.96,219.04
             1276.20,230.91 1279.07,244.54 1279.56,259.94
             1280.33,284.23 1280.45,308.09 1279.90,331.52
             1278.98,370.18 1265.30,404.84 1225.06,415.62
             1216.30,417.95 1201.85,418.93 1181.70,418.56
             1168.63,418.32 1153.50,418.29 1136.30,418.48
             1136.29,418.48 1136.29,418.48 1136.28,418.48
             1134.95,418.48 1133.88,417.41 1133.88,416.08
             1133.88,416.08 1133.88,416.08 1133.88,416.08
             1133.88,416.08 1133.88,182.94 1133.88,182.94 Z
           M 1178.08,298.64
           C 1178.03,326.40 1177.98,352.11 1177.94,375.78
             1177.94,375.78 1177.94,375.78 1177.94,375.78
             1177.94,376.26 1178.32,376.65 1178.80,376.66
             1200.96,376.96 1225.10,379.28 1231.14,351.42
             1234.84,334.36 1234.14,317.98 1234.18,298.76
             1234.24,279.52 1235.00,263.16 1231.38,246.08
             1225.46,218.20 1201.32,220.40 1179.16,220.60
             1179.16,220.60 1179.16,220.60 1179.16,220.60
             1178.67,220.60 1178.28,220.99 1178.28,221.48
             1178.21,245.15 1178.15,270.87 1178.08,298.64 Z
           M 1022.88,181.10
           C 1033.24,181.07 1041.57,181.08 1047.88,181.12
             1049.68,181.13 1051.18,182.39 1051.56,184.08
             1051.56,184.08 1103.02,413.98 1103.02,413.98
             1103.08,414.23 1103.11,414.49 1103.11,414.76
             1103.11,416.74 1101.50,418.34 1099.53,418.34
             1099.52,418.34 1099.52,418.34 1099.52,418.34
             1099.52,418.34 1060.24,418.34 1060.24,418.34
             1058.61,418.34 1057.21,417.18 1056.92,415.58
             1056.92,415.58 1048.14,368.56 1048.14,368.56
             1048.07,368.16 1047.75,367.86 1047.36,367.82
             1046.16,367.70 1038.10,367.65 1023.18,367.68
             1008.25,367.71 1000.19,367.78 999.00,367.90
             998.61,367.94 998.29,368.24 998.22,368.64
             998.22,368.64 989.58,415.68 989.58,415.68
             989.30,417.28 987.91,418.45 986.28,418.46
             986.28,418.46 947.00,418.58 947.00,418.58
             946.99,418.58 946.99,418.58 946.98,418.58
             945.00,418.58 943.40,416.98 943.40,415.00
             943.40,414.74 943.43,414.48 943.48,414.24
             943.48,414.24 994.22,184.16 994.22,184.16
             994.60,182.48 996.09,181.22 997.88,181.20
             1004.20,181.15 1012.53,181.11 1022.88,181.10 Z
           M 1023.24,331.14
           C 1029.00,331.11 1034.63,331.09 1040.12,331.06
             1040.68,331.06 1041.14,330.60 1041.14,330.04
             1041.14,329.98 1041.13,329.92 1041.12,329.86
             1031.27,277.70 1025.27,245.57 1023.12,233.48
             1023.04,233.04 1022.87,232.82 1022.62,232.82
             1022.35,232.82 1022.19,233.04 1022.12,233.48
             1020.13,245.60 1014.54,277.80 1005.34,330.08
             1005.33,330.14 1005.32,330.20 1005.32,330.26
             1005.32,330.82 1005.78,331.28 1006.34,331.28
             1011.85,331.23 1017.48,331.18 1023.24,331.14 Z
           M 868.08,328.96
           C 868.13,329.01 868.20,329.04 868.28,329.04
             868.44,329.04 868.58,328.90 868.58,328.74
             868.58,328.74 868.58,183.44 868.58,183.44
             868.58,182.14 869.65,181.08 870.96,181.08
             870.96,181.08 907.50,181.08 907.50,181.08
             908.91,181.08 910.06,182.22 910.06,183.62
             910.06,183.62 910.06,415.78 910.06,415.78
             910.06,415.78 910.06,415.78 910.06,415.78
             910.06,417.34 908.80,418.60 907.24,418.60
             907.24,418.60 865.42,418.60 865.42,418.60
             863.84,418.60 862.41,417.62 861.86,416.14
             861.86,416.14 804.40,265.18 804.40,265.18
             804.35,265.01 804.19,264.89 804.00,264.89
             803.77,264.89 803.58,265.08 803.58,265.31
             803.58,265.31 803.58,265.32 803.58,265.32
             803.54,270.06 804.60,279.16 804.60,286.26
             804.51,354.95 804.46,396.87 804.46,412.00
             804.47,413.88 804.41,415.28 804.28,416.20
             804.08,417.54 802.92,418.54 801.56,418.54
             801.56,418.54 766.54,418.54 766.54,418.54
             765.29,418.54 764.28,417.52 764.28,416.26
             764.28,416.26 764.28,183.30 764.28,183.30
             764.28,183.30 764.28,183.30 764.28,183.30
             764.28,182.04 765.29,181.02 766.54,181.02
             766.54,181.02 810.62,181.02 810.62,181.02
             810.62,181.02 810.62,181.02 810.62,181.02
             812.16,181.02 813.47,181.99 813.98,183.36
             842.74,260.35 860.45,308.33 867.12,327.32
             867.39,328.07 867.71,328.61 868.08,328.96 Z
           M 445.02,696.50
           C 425.20,701.62 416.70,682.46 428.34,668.24
             432.01,663.76 436.56,659.68 442.00,656.00
             461.81,642.56 480.51,628.26 498.08,613.10
             514.15,599.23 530.94,581.02 548.46,558.46
             593.16,500.94 621.70,426.92 618.66,353.46
             614.12,244.36 537.60,151.54 431.28,126.40
             334.96,103.64 234.14,138.82 166.02,209.58
             151.59,224.57 138.73,242.36 127.44,262.96
             100.49,312.13 89.83,365.65 95.46,423.52
             104.02,511.66 141.22,597.96 194.26,667.68
             243.88,732.90 311.92,787.40 390.44,811.64
             405.49,816.29 417.03,819.05 425.06,819.92
             441.30,821.68 459.00,822.38 470.20,832.22
             479.72,840.60 478.04,855.72 465.72,860.76
             459.10,863.46 451.74,864.38 445.24,864.26
             428.68,863.94 411.79,861.47 394.56,856.86
             291.58,829.22 207.36,762.48 145.96,675.92
             90.80,598.17 59.59,510.88 52.34,414.04
             49.59,377.44 52.80,343.12 61.96,311.08
             71.68,277.08 85.93,245.61 104.70,216.68
             152.14,143.52 233.90,93.46 319.34,80.10
             416.40,64.92 513.82,98.58 582.70,167.78
             627.62,212.90 652.14,268.32 658.12,331.92
             666.48,420.94 635.40,510.08 580.94,581.04
             547.32,624.84 506.70,662.66 459.28,690.80
             455.28,693.17 450.53,695.07 445.02,696.50 Z"
      />
      {/* <path
        id="Selection"
        fill="#7f188c"
        d="M 469.00,225.24
           C 471.93,225.06 474.04,224.95 477.00,225.24
             519.85,226.00 530.94,285.86 492.00,302.66
             486.32,305.11 480.15,306.13 474.00,305.99
             442.04,305.25 424.54,269.26 441.55,243.00
             448.34,232.51 457.17,228.02 469.00,225.24 Z
           M 273.00,260.46
           C 284.80,258.83 297.43,262.32 305.82,271.09
             321.30,287.29 318.74,315.12 300.00,327.64
             295.49,330.65 290.33,332.58 285.00,333.54
             250.36,339.78 228.63,297.97 251.32,272.04
             257.16,265.37 264.58,262.33 273.00,260.46 Z
           M 366.00,321.24
           C 368.93,321.06 371.04,320.95 374.00,321.24
             414.49,321.95 424.95,378.19 389.00,394.48
             383.18,397.12 377.34,398.13 371.00,397.99
             342.77,397.34 325.56,366.85 337.99,342.00
             343.93,330.13 353.43,324.25 366.00,321.24 Z
           M 202.00,362.24
           C 204.93,362.06 207.04,361.95 210.00,362.24
             244.25,362.80 260.66,404.46 236.56,428.56
             233.23,431.89 229.35,434.70 225.00,436.54
             218.89,439.11 213.60,440.14 207.00,439.99
             180.29,439.37 161.80,411.94 171.47,387.00
             176.88,373.03 187.85,365.60 202.00,362.24 Z"
      /> */}
    </chakra.svg>
  );
};

export default Logo;
